export default function Empty() {
  return 'No resources match the selected filters.';
}
